/* import __COLOCATED_TEMPLATE__ from './saved-messages-button.hbs'; */
import Component from '@ember/component';

/**
 * A component which renders a saved messages button.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'button',
  classNames: ['SH-c-saved-messages-button'],
  attributeBindings: ['_title:title', 'type'],

  /**
   * @type {String} The title attribute for the element.
   */
  _title: 'Saved messages',

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * The function to call when the element receives a click event.
   */
  handleClick: () => (function() {}),

  /*********************************
   * OPTIONAL PARAMS
   *********************************/

  /**
   * The click handler.
   */
  click(event) {
    this.get('handleClick')(event);
  },
});
